"use client";
import { useEffect, useRef } from "react";
import { decode } from "blurhash";

export function BlurhashCanvas({ hash, className }: { hash: string; className?: string }) {
  const ref = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    try {
      const pixels = decode(hash, 32, 32);
      const ctx = canvas.getContext("2d");
      if (!ctx) return;
      const img = ctx.createImageData(32, 32);
      img.data.set(pixels);
      ctx.putImageData(img, 0, 0);
    } catch {
      // bad hash: leave canvas blank, the photo still loads on top
    }
  }, [hash]);
  return <canvas ref={ref} width={32} height={32} className={className} aria-hidden />;
}
